import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { loadRuntimeConfig } from './environments/runtime-config';

// ⚠️ AppModule is reached through a DYNAMIC import() below and is deliberately NOT
// imported at the top of this file (INTO-324). Its decorator metadata reads
// environment.AUTH0_* and environment.BASE_API_URL while the module is evaluated,
// and a static import is hoisted above every statement here -- so it would capture
// the compiled values before loadRuntimeConfig() could overlay config.json.
// Making this a static import again would silently reinstate the baked-in URLs.
// See ./environments/runtime-config.ts.
loadRuntimeConfig()
  .then(async () => {
    if (environment.production) {
      enableProdMode();
    }

    const { AppModule } = await import('./app/app.module');

    return platformBrowser().bootstrapModule(AppModule, {
      applicationProviders: [provideZoneChangeDetection()],
    });
  })
  .catch((err) => {
    console.error(err);
    // Bootstrap failed, so AppComponent.ngOnInit will never clear the loader.
    // Leaving it spinning looks like progress; show the failure instead.
    const loader = document.getElementById('app-loading');
    if (loader) {
      loader.innerHTML =
        '<div style="font:14px system-ui;color:#424242;text-align:center;padding:24px">' +
        'The application failed to start.<br />Please reload the page.</div>';
    }
  });
